import React, { useEffect, useState, useRef } from "react";
import "./testimonial.css";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import 'primeicons/primeicons.css';


function Testimonial() {
  const [testimonials, setTestimonials] = useState([]);
  const [index, setIndex] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    location: "",
    testimonial: "",
  });

  const toast = useRef(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/fetchtestimonial"
        );
        const result = await response.json();
        if (result.status && Array.isArray(result.data)) {
          setTestimonials(result.data);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const prevTestimonial = () => {
    setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextTestimonial = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    confirmDialog({
      group: "testimonial",
      message: "Are you sure you want to Proceed?",
      header: "Confirmation",
      icon: "pi pi-question",
      defaultFocus: "accept",
      accept: () => {
        submitTestimonial();
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Your testimonial has been submitted.",
          life: 3000,
          className: "custom-toast success-toast"
        });
      },
      reject: () => {
        toast.current.show({
          severity: "warn",
          summary: "Canceled",
          detail:"Your testimonial has been canceled.",
          life: 3000,
          className: "custom-toast warning-toast"
        });
      }
    });
  };

  const submitTestimonial = async () => {
    try {
      const response = await fetch(
        "https://dashboard.jyotirvani.com/api/addtestimonial",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (result.status) {
        setTestimonials((prev) => [...prev, formData]);
        setFormData({
          name: "",
          email: "",
          location: "",
          testimonial: "",
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to submit. Please try again.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error submitting testimonial:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong. Please try again.",
        life: 3000,
      });
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      
      {/* Custom confirmation dialog */}
      <ConfirmDialog
        group="testimonial"
        content={({ headerRef, contentRef, footerRef, hide, message }) => (
          <div className="custom-confirm-dialog">
            <div className="icon-circle">
              <i className="pi pi-question"></i>
            </div>
            <div className="header" ref={headerRef}>
              {message.header}
            </div>
            <div className="message" ref={contentRef}>
              {message.message}
            </div>
            <div className="button-group" ref={footerRef}>
              <Button
                 label="Save"
  className="custom-save-button p-button-success"
                onClick={(event) => {
                  hide(event);
                  submitTestimonial();
                  toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Your testimonial has been submitted.",
                    life: 3000,
                    className: "custom-toast success-toast"
                  });
                }}
                
              />
              <Button
                  label="Cancel"
  className="custom-cancel-button"
  outlined
                onClick={(event) => {
                  hide(event);
                  toast.current.show({
                    severity: "warn",
                    summary: "Rejected",
                    detail: "You have rejected.",
                    life: 3000,
                    className: "custom-toast warning-toast"
                  });
                }}
              />
            </div>
          </div>
        )}
      />

      <div className="testimonial-feedback-section">
        <div className="testimonial-box">
          <h2>Testimonials</h2>
          {testimonials.length > 0 ? (
            <div className="testimonial-content">
              <button className="ra-home-testimonial-arrow" onClick={prevTestimonial}>
                &#8249;
              </button>
              <div className="testimonial-text">
                <p className="ra-home-testimonial-quote">
                  “ {testimonials[index].testimonial} ”
                </p>
                <p className="ra-home-testimonial-author">
                  {testimonials[index].name}
                </p>
                <p className="ra-home-testimonial-location">
                  {testimonials[index].location}
                </p>
              </div>
              <button className="ra-home-testimonial-arrow" onClick={nextTestimonial}>
                &#8250;
              </button>
            </div>
          ) : (
            <p>No testimonials available yet.</p>
          )}
        </div>

        <div className="ra-home-testimonial-feedback-box">
          <h2>Feedback</h2>
          <form
            onSubmit={handleSubmit}
            className="ra-home-testimonial-feedback-form"
          >
            <div className="ra-home-testimonial-form-row">
              <label htmlFor="name">
                Name <span className="ra-home-testimonial-required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                required
                onChange={handleChange}
              />
            </div>

            <div className="ra-home-testimonial-form-row">
              <label htmlFor="email">
                Email <span className="ra-home-testimonial-required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                required
                onChange={handleChange}
              />
            </div>

            <div className="ra-home-testimonial-form-row">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </div>

            <div className="ra-home-testimonial-form-row">
              <label htmlFor="testimonial">Testimonial</label>
              <textarea
                id="testimonial"
                name="testimonial"
                value={formData.testimonial}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="ra-home-testimonial-submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Testimonial;
